import React from 'react';
import { ICONS, ICON_GRID, pathOf } from './icon-set.js';

// ============================================================================
// <LcIcon> —— 图标集的 web 渲染器（图标专项，2026-08-09）
//
// 一个组件，一份数据（icon-set.js），零依赖。存在的理由见 icon-set.js 顶部：
// emoji 与文本字形当图标用，颜色不归我们管。
//
// 【颜色】永远 `currentColor`。调用点写 `style={{ color: 'var(--lc-main)' }}`
// 或者干脆让它继承 —— 无论哪种，最终落在 --lc-* token 上。组件自己**一个颜色
// 字面量都不写**：写死颜色的 SVG 只是把系统的黄换成我们的黄，等于没改。
//
// 【无障碍】默认 `aria-hidden`：这批图标全部伴着文字出现（"✓ 选项 A"、
// "⭐ 给这次服务打分"），单独播报只会读出重复内容。确实要当独立控件用时，
// 调用点自己给按钮加 aria-label —— 那是按钮的事，不是图标的事。
//
// 【尺寸】`size` 是 CSS px；网格是 24，描边宽度按比例缩放，所以 12px 的图标
// 线不会看起来比 24px 的粗。
// ============================================================================

export default function LcIcon({ name, size = 16, strokeWidth, style, className }) {
    const icon = ICONS[name];
    // 未知名字返回 null 而不是画个占位方块：一个静默的空洞比一个错误的图形好，
    // 而拼错名字会被 icon-set 的金样测试在构建前抓住。
    if (!icon) return null;
    const sw = strokeWidth != null ? strokeWidth : (icon.strokeWidth || 2);
    const common = {
        stroke: 'currentColor',
        strokeWidth: sw,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        fill: 'none',
    };
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox={`0 0 ${ICON_GRID} ${ICON_GRID}`}
            fill="none"
            aria-hidden="true"
            focusable="false"
            style={{ display: 'block', flexShrink: 0, ...style }}
        >
            {icon.shapes.map((s, i) => {
                if (s.type === 'circle') {
                    return s.fill
                        ? <circle key={i} cx={s.cx} cy={s.cy} r={s.r} fill="currentColor" />
                        : <circle key={i} {...common} cx={s.cx} cy={s.cy} r={s.r} />;
                }
                if (s.type === 'rect') {
                    return <rect key={i} {...common} x={s.x} y={s.y} width={s.w} height={s.h} rx={s.rx} />;
                }
                if (s.type === 'star') {
                    return <path key={i} d={pathOf(s)} fill="currentColor" />;
                }
                return <path key={i} {...common} d={pathOf(s)} />;
            })}
        </svg>
    );
}
